/**** mgt.ControllerEquipment */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'ControllerEquipment',
  title: 'Оборудование сотрудников',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    driver: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Driver',
      index: 'driver_id',
      fields: ['last_name', 'first_name', 'middle_name'],
      format: (elem: any) =>
        `${elem['last_name'] || ''} ${elem['first_name'] || ''} ${elem[
          'middle_name'
        ] || ''}`,
      autocomplete: true,
    },
    controllerequipmenttype: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'ControllerEquipmentType',
      index: 'pu_model_id',
      fields: ['pu_model_name'],
      format: (elem: any) => elem['pu_model_name'],
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'pu_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'worker_id',
      title: 'Сотрудник',
      type: 'number',
      required: false,
      connection: 'driver'
    },
    {
      name: 'pu_model_id',
      title: 'Модель оборудования',
      type: 'number',
      required: true,
      connection: 'controllerequipmenttype'
    }
  ],
  newTemplate: {
    pu_id: null,
    worker_id: null,
    pu_model_id: null,
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'pu_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'pu_id',
        field: 'pu_id',
      },{
        title: 'worker_id',
        field: 'worker_id',
      },{
        title: 'pu_model_id',
        field: 'pu_model_id',
      }
    ],
    example: `1;1;1`,
  }

};

export default config;